/** Short Terms & Conditions for signup — matches app disclaimer style. */
export const TERMS_POINTS = [
  'Xlog3D is a decision-support and visualisation tool intended for use by qualified engineering geology and tunnelling professionals.',
  'Outputs must be interpreted using professional judgment and in conjunction with site observations, investigations, and other analyses.',
  'The developers shall not be liable for decisions taken solely on the basis of software outputs.',
  'Free Trial with Limited Features includes D-Shape only for a limited period, with watermarked output. One trial per account.',
  'Paid plans unlock full modules (D-Shape, Horseshoe, Circular, Shaft). You are responsible for keeping your account credentials secure.',
];
